import { useNavigate, useLocation } from "react-router-dom";
import talentLogo2 from "../assets/talentlogo2.png";
import { getAppDisplayTimezone } from "../utils/appDateTime";
import { resolveKioskSearchFromStorage } from "./deviceKiosk";

export default function DeviceKioskHeader({ now = new Date() }) {
  const navigate = useNavigate();
  const location = useLocation();

  const formatted = now.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: getAppDisplayTimezone(),
  });

  const handleLogoClick = () => {
    // 1. First check if we have URL search params that satisfy kiosk checkin
    const urlParams = new URLSearchParams(location.search);
    const clientId = urlParams.get("clientId");
    const client = urlParams.get("client");
    const from = urlParams.get("from");

    if (clientId && client && from) {
      navigate(`/checkin?${urlParams.toString()}`);
      return;
    }

    // 2. Then check if we have a valid kiosk context in storage
    const kioskSearch = resolveKioskSearchFromStorage();
    if (kioskSearch) {
      navigate(`/checkin?${kioskSearch.toString()}`);
      return;
    }

    // 3. Fallback to /device
    navigate("/device");
  };

  return (
    <header className="flex items-start justify-between p-4">
      <div className="cursor-pointer" onClick={handleLogoClick}>
        <img src={talentLogo2} alt="Talent Logo" className="h-12 w-auto" />
      </div>
      <div className="text-right">
        <div className="text-xl font-bold text-gray-800">{formatted}</div>
      </div>
    </header>
  );
}
